import {
    CURRENT_STEP,
    CREATE_STEP,
    ADD_CHILD_STEP,
    NEXT_STEP,
    PREVIOUS_STEP,
    TOGGLE_VALID_STEP,
} from "../actions";

const initialState = [];

const childStepIds = (state, action) => {
    switch (action.type) {
    case ADD_CHILD_STEP:
        return [...state, action.childStepId];
    default:
        return state;
    }
}

let completed = false;
let active = true;

const step = (state = initialState, action) => {
    switch (action.type) {
    case CREATE_STEP:
        return {
            id: action.id,
            name: action.name,
            completed: action.completed,
            current: action.current,
            active: action.active,
            parentId: action.parentId,
            valid: action.valid,
            childStepIds: []
        };
    case TOGGLE_VALID_STEP:
        return (state.id === action.id)
            ? { ...state, valid: action.valid }
            : state;
    case CURRENT_STEP:
    case PREVIOUS_STEP:
    case NEXT_STEP:
        if (state.id === action.id) {
            completed = false;
            active = false;
        }

        return (state.id === action.id)
            ? { ...state, completed, active, current: true, previousStep: action.currentStep }
            : { ...state, completed, active, current: false, previousStep: action.currentStep };
    case ADD_CHILD_STEP: // case REMOVE_CHILD_STEP:
        if (state.id !== action.id) {
            return state;
        }

        if (state.childStepIds.some(id => id === action.childStepId)) {
            return state;
        }

        return {
            ...state,
            childStepIds: childStepIds(state.childStepIds, action)
        }
    default:
        return state
    }
}

const steps = (state = [], action) => {
    switch (action.type) {
    case CREATE_STEP:
        if (state.some(_step => _step.id === action.id)) {
            return state;
        }

        return [
            ...state,
            step(undefined, action)
        ]
    case TOGGLE_VALID_STEP:
        return state.map((_step) => step(_step, action));
    case CURRENT_STEP:
    case PREVIOUS_STEP:
    case NEXT_STEP:
        completed = true;
        active = true;

        if(action.type === PREVIOUS_STEP && state[0].current === true) {
            return state;
        }

        if(action.type === NEXT_STEP && state[state.length - 1].current === true) {
            return state;
        }

        // eslint-disable-next-line no-case-declarations
        const act = {
            ...action,
            currentStep: state.find(_step => _step.current === true)
        }

        return state.map((_step) => step(_step, act));
    case ADD_CHILD_STEP:
        return state.map(_step => step(_step, action));
    default:
        return state;
    }
};

export default steps;
